import { useCallback, useContext, useMemo, useSyncExternalStore } from "react";

import { type AccountLookup, AccountLookupSnapshot } from "@/hooks/workspace/accountSnapshots";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";
import { store } from "@/store/store";

/**
 * An account lookup for the current workspace, for identity fields inside memos and plain functions.
 *
 * Its identity changes only on writes to accounts, memberships or aliases, never on availability, so availability
 * fields on its rows may be stale. Live status goes through `useAccountStatus`.
 */
export function useAccountLookup(): AccountLookup {
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const snapshot = useMemo(() => new AccountLookupSnapshot(currentWorkspaceId), [currentWorkspaceId]);
  const subscribe = useCallback((listener: () => void) => store.subscribeWrites(listener), []);
  return useSyncExternalStore(subscribe, snapshot.read);
}
